var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHarddiskIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F8F8F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_780)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1664 16.7846L21.8581 11.5138C21.8069 11.3415 21.7013 11.1904 21.5571 11.083C21.4129 10.9756 21.2379 10.9177 21.0581 10.918H11.9414C11.7588 10.9178 11.5812 10.9777 11.4359 11.0884C11.2906 11.199 11.1857 11.3544 11.1373 11.5305L9.83309 16.7846C9.82907 16.8178 9.82907 16.8514 9.83309 16.8846V20.0846C9.83309 20.3057 9.92089 20.5176 10.0772 20.6739C10.2334 20.8302 10.4454 20.918 10.6664 20.918H22.3331C22.5541 20.918 22.7661 20.8302 22.9223 20.6739C23.0786 20.5176 23.1664 20.3057 23.1664 20.0846V16.8805C23.1701 16.8486 23.1701 16.8165 23.1664 16.7846ZM10.6664 20.0846V16.9346L11.9414 11.7513H21.0539L22.3331 16.9346V20.0846H10.6664Z",
    fill: "#16151C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.332H21.5V17.1654H11.5V16.332Z",
    fill: "#16151C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.833 18H21.4997V18.8333H19.833V18Z",
    fill: "#16151C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_780"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarddiskIcon);
export default __webpack_public_path__ + "static/media/harddisk-icon.7c2561ea2d3fc35a851977bcaf4f2eec.svg";
export { ForwardRef as ReactComponent };